(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["sognato-avis"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('sog-avis-slider')) return;
    class SogAvisSlider extends HTMLElement {
      connectedCallback() {
        const track = this.querySelector('[data-track]');
        const step = (dir) => {
          const card = track.querySelector('li');
          const w = card ? card.getBoundingClientRect().width + 12 : track.clientWidth;
          track.scrollBy({ left: dir * w, behavior: 'smooth' });
        };
        this.querySelector('[data-prev]')?.addEventListener('click', () => step(-1));
        this.querySelector('[data-next]')?.addEventListener('click', () => step(1));
      }
    }
    customElements.define('sog-avis-slider', SogAvisSlider);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sognato-collection-grille"]) return;
  try {
    
  (() => {
    if (!customElements.get('sognato-card')) {
      class SognatoCard extends HTMLElement {
        connectedCallback() {
          const faces = [...this.querySelectorAll('[data-face]')];
          const link = this.querySelector('[data-card-link]');
          const show = (i) => {
            faces.forEach((f) => {
              const on = f.dataset.face === String(i);
              f.hidden = !on;
              if (on && link) link.href = f.dataset.url;
            });
            this.querySelectorAll('[data-sw]').forEach((b) => {
              const on = b.dataset.sw === String(i);
              b.classList.toggle('is-on', on);
              b.setAttribute('aria-pressed', String(on));
            });
          };
          this.querySelectorAll('[data-sw]').forEach((b) => b.addEventListener('click', () => show(b.dataset.sw)));
        }
      }
      customElements.define('sognato-card', SognatoCard);
    }

    document.querySelectorAll('[data-cg-form]').forEach((form) => {
      if (form.dataset.ready) return;
      form.dataset.ready = '1';
      const dialog = form.querySelector('[data-cg-dialog]');
      form.querySelector('[data-cg-open]')?.addEventListener('click', () => dialog?.showModal());
      form.querySelector('[data-cg-close]')?.addEventListener('click', () => dialog?.close());
      dialog?.addEventListener('click', (e) => {
        if (e.target === dialog) dialog.close();
      });
      form.querySelectorAll('[data-cg-submit]').forEach((el) => el.addEventListener('change', () => form.requestSubmit()));
      const root = form.closest('.sog-cg');
      const desk = window.matchMedia('(width > 989px)');
      if (root && root.classList.contains('sog-cg--side-d') && dialog) {
        dialog.addEventListener('change', () => {
          if (desk.matches && !dialog.open) form.requestSubmit();
        });
        dialog.addEventListener('keydown', (e) => {
          if (e.key === 'Enter' && desk.matches && !dialog.open && e.target.matches('input')) {
            e.preventDefault();
            form.requestSubmit();
          }
        });
      }
      form.addEventListener('submit', () => {
        form.querySelectorAll('input[type=number]').forEach((i) => {
          if (i.value === '') i.disabled = true;
        });
      });

      const tools = form.querySelector('.sog-cg__tools.is-sticky');
      if (tools) {
        let ticking = false;
        const place = () => {
          ticking = false;
          const header = document.querySelector('header.shopify-section, .shopify-section-group-header-group[id*="header"]');
          const bottom = header ? Math.max(0, Math.round(header.getBoundingClientRect().bottom)) : 0;
          tools.style.setProperty('--sog-cg-top', bottom + 'px');
          form.closest('.sog-cg')?.style.setProperty('--sog-cg-head', bottom + 'px');
        };
        const ask = () => {
          if (!ticking) {
            ticking = true;
            requestAnimationFrame(place);
          }
        };
        window.addEventListener('scroll', ask, { passive: true });
        window.addEventListener('resize', ask);
        place();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sognato-description"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('sognato-desc')) return;
    class SognatoDesc extends HTMLElement {
      connectedCallback() {
        const body = this.querySelector('[data-sd-body]');
        const btn = this.querySelector('[data-sd-more]');
        if (!body || !btn) return;
        const max = parseInt(getComputedStyle(this).getPropertyValue('--sd-collapse'), 10) || 360;
        if (body.scrollHeight <= max + 40) return;
        this.classList.add('is-collapsed');
        btn.hidden = false;
        btn.addEventListener('click', () => {
          const open = this.classList.toggle('is-collapsed') === false;
          btn.setAttribute('aria-expanded', String(open));
          btn.querySelector('[data-sd-open]').hidden = open;
          btn.querySelector('[data-sd-close]').hidden = !open;
        });
      }
    }
    customElements.define('sognato-desc', SognatoDesc);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sognato-dimensions"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('sognato-dim')) return;
    class SognatoDim extends HTMLElement {
      connectedCallback() {
        this.onUpdate = (e) => {
          const v = e.detail && e.detail.resource;
          if (v && v.option1) this.mark(v.option1);
        };
        this.onChange = (e) => {
          const t = e.target;
          if (t && t.name && t.name.indexOf('option-') === 0 && t.value) this.mark(t.value);
        };
        document.addEventListener('variant:updated', this.onUpdate);
        document.addEventListener('change', this.onChange);
      }
      disconnectedCallback() {
        document.removeEventListener('variant:updated', this.onUpdate);
        document.removeEventListener('change', this.onChange);
      }
      mark(size) {
        this.querySelectorAll('[data-sdm-row]').forEach((r) => {
          r.classList.toggle('is-active', r.dataset.sdmRow.trim() === String(size).trim());
        });
      }
    }
    customElements.define('sognato-dim', SognatoDim);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sognato-guide"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('sognato-guide')) return;
    class SognatoGuide extends HTMLElement {
      connectedCallback() {
        const btns = [...this.querySelectorAll('[data-sg-btn]')];
        btns.forEach((b) =>
          b.addEventListener('click', () => {
            btns.forEach((x) => {
              const on = x === b;
              x.classList.toggle('is-on', on);
              x.setAttribute('aria-pressed', String(on));
              const panel = document.getElementById(x.getAttribute('aria-controls'));
              if (panel) panel.hidden = !on;
            });
          })
        );
      }
    }
    customElements.define('sognato-guide', SognatoGuide);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sognato-recommandations"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const load = (el) => {
      if (el.dataset.loaded || !el.dataset.url || el.querySelector('.sog-reco__list')) return;
      el.dataset.loaded = '1';
      fetch(el.dataset.url)
        .then((r) => r.text())
        .then((html) => {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const fresh = doc.querySelector('[data-sog-reco]');
          if (fresh && fresh.querySelector('.sog-reco__list')) {
            el.innerHTML = fresh.innerHTML;
          } else if (!window.Shopify || !window.Shopify.designMode) {
            el.closest('.shopify-section')?.setAttribute('hidden', '');
          }
        })
        .catch(() => {});
    };

    const init = () => {
      document.querySelectorAll('[data-sog-reco]').forEach((el) => {
        if (!('IntersectionObserver' in window)) return load(el);
        const io = new IntersectionObserver((entries) => {
          if (entries.some((e) => e.isIntersecting)) {
            io.disconnect();
            load(el);
          }
        }, { rootMargin: '400px 0px' });
        io.observe(el);
      });
    };

    init();
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sognato-tailles"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const fill = () => {
      document.querySelectorAll('[data-tai-count]:not([data-tai-done])').forEach((el) => {
        el.dataset.taiDone = '1';
        fetch(el.dataset.taiCount)
          .then((r) => (r.ok ? r.json() : null))
          .then((data) => {
            if (!data || !Array.isArray(data.products)) return;
            const n = data.products.filter((p) => (p.variants || []).some((v) => v.available)).length;
            if (n > 0) {
              el.textContent = n + ' ' + (el.dataset.taiLabel || '');
              el.hidden = false;
            }
          })
          .catch(() => {});
      });
    };
    fill();
    document.addEventListener('shopify:section:load', fill);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sognato-texte"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('sognato-texte')) return;
    class SognatoTexte extends HTMLElement {
      connectedCallback() {
        if (!this.classList.contains('can-collapse')) return;
        const body = this.querySelector('[data-tx-body]');
        const btn = this.querySelector('[data-tx-more]');
        if (!body || !btn) return;
        const max = parseInt(getComputedStyle(this).getPropertyValue('--tx-collapse'), 10) || 320;
        if (body.scrollHeight <= max + 40) return;
        this.classList.add('is-collapsed');
        btn.hidden = false;
        btn.addEventListener('click', () => {
          const open = this.classList.toggle('is-collapsed') === false;
          btn.setAttribute('aria-expanded', String(open));
          btn.querySelector('[data-tx-open]').hidden = open;
          btn.querySelector('[data-tx-close]').hidden = !open;
        });
      }
    }
    customElements.define('sognato-texte', SognatoTexte);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sognato-whatsapp-flottant"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const run = () => {
      document.querySelectorAll('[data-wa-float]:not([data-wa-ready])').forEach((wa) => {
        wa.dataset.waReady = '1';
        const gap = parseInt(wa.dataset.gap, 10) || 0;
        let frame = 0;

        const place = () => {
          frame = 0;
          let lift = 0;
          if (wa.dataset.aboveSticky === 'true') {
            document.querySelectorAll('sticky-add-to-cart, .sticky-add-to-cart').forEach((bar) => {
              if (bar.dataset.active === 'false') return;
              const cs = getComputedStyle(bar);
              if (cs.display === 'none' || cs.visibility === 'hidden' || cs.position !== 'fixed') return;
              const r = bar.getBoundingClientRect();
              if (r.height > 0 && r.top < window.innerHeight && r.bottom > window.innerHeight - 4) {
                lift = Math.max(lift, window.innerHeight - r.top);
              }
            });
          }
          if (lift > 0) {
            wa.style.setProperty('--wa-offset', Math.round(lift + gap) + 'px');
          } else {
            wa.style.removeProperty('--wa-offset');
          }
        };

        const ask = () => {
          if (!frame) frame = requestAnimationFrame(place);
        };

        // suit la barre pendant son animation d'apparition / disparition
        const follow = () => {
          const end = performance.now() + 500;
          const step = () => {
            place();
            if (performance.now() < end) requestAnimationFrame(step);
          };
          requestAnimationFrame(step);
        };

        window.addEventListener('scroll', ask, { passive: true });
        window.addEventListener('resize', ask);
        const watch = () => {
          document.querySelectorAll('sticky-add-to-cart, .sticky-add-to-cart').forEach((bar) => {
            if (bar.dataset.waWatched) return;
            bar.dataset.waWatched = '1';
            new MutationObserver(follow).observe(bar, { attributes: true, attributeFilter: ['data-active', 'class', 'style', 'hidden'] });
            bar.addEventListener('transitionend', ask);
          });
        };
        watch();
        setTimeout(() => {
          watch();
          place();
        }, 1500);
        place();
      });
    };
    run();
    document.addEventListener('shopify:section:load', run);
  })();

  } catch(e) { console.error(e); }
})();
})();
